"use strict";
/*
 * Created on 20/08/2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PriceArchitectureDTOConverter
 *
 * @author JMr
 */


var PriceArchitectureDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceArchitectureDTOConverter, _DataObjectConverter_);

  function PriceArchitectureDTOConverter() {
    _classCallCheck(this, PriceArchitectureDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceArchitectureDTOConverter).apply(this, arguments));
  }

  return PriceArchitectureDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceArchitectureDTOConverter = PriceArchitectureDTOConverter;